import(/* webpackMode: "eager" */ "/codebuild/output/src3330220393/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
